// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bulb-assignments.dark{background-color:#383838!important}.dark div .dark h1,.dark h2,.dark h3,.dark i,.dark span{color:#fff!important}.log-data li,.log-header{display:flex}.log-header{padding:24px 24px 0 24px}.log-column-header{list-style-type:none;flex:1 1}.log-data{padding:0 24px 24px 24px;max-height:500px;overflow:auto}.log-data li span{flex:1 1}#bulbActivityBox{max-height:300px;overflow:auto}", ""]);
// Exports
module.exports = exports;
